import { errorStatus } from '@/api/errors';

let syncEndpointAvailable: boolean | null = null;

export function isEmailSyncEnabled(): boolean {
  return syncEndpointAvailable !== false;
}

export function markEmailSyncUnavailable(): void {
  syncEndpointAvailable = false;
}

export function resetEmailSyncAvailabilityForTests(): void {
  syncEndpointAvailable = null;
}

export function shouldDisableEmailSync(error: unknown): boolean {
  const status = errorStatus(error);
  return status === 404 || status === 405 || status === 501;
}
